import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import StatisticsCards from '@/views/dashboard/_components/statistics-cards/statistics-cards.vue'
import type { SecurityEventOverview } from '../types'


export default /*#__PURE__*/_defineComponent({
  __name: 'security-event-statistics-cards',
  props: {
    overview: {}
  },
  emits: ["statClick"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const { t, locale } = useI18n()

const cardItems = computed(() => {
  void locale.value
  return [
  {
    label: t('securityEvent.statNew30d'),
    value: props.overview.new_events_30d,
    clickable: true,
  },
  {
    label: t('securityEvent.statPending'),
    value: props.overview.pending_count,
    clickable: true,
  },
  {
    label: t('securityEvent.statTrusted'),
    value: props.overview.trusted_count,
    clickable: true,
  },
  {
    label: t('securityEvent.statIgnored'),
    value: props.overview.ignored_count,
    clickable: true,
  },
]})

const STAT_KEYS = ['new30d', 'pending', 'trusted', 'ignored'] as const

function onItemClick (index: number) {
  const key = STAT_KEYS[index]
  if (key) emit('statClick', key)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(StatisticsCards, {
    items: cardItems.value,
    onItemClick: onItemClick
  }, null, 8, ["items"]))
}
}

})